import React from 'react';
import classnames from 'classnames';
import styles from './styles.scss';

export default function Hr({ className }) {
  return (
    <hr className={classnames(styles.hr, className)} />
  );
}
